// extracted by mini-css-extract-plugin
export var closeButton = "_mq-2";
export var closeButtonIcon = "_mq-3";
export var lightboxContent = "_mq-1";
export var lightboxOverlay = "_mq-0";